import React from 'react'

import * as css from './ZoomImagen.css'

var zoomImagen = [
    css.imagenZoom,
    css.imagenZoom1,
    css.imagenZoom2,
    css.imagenZoom3,
    css.imagenZoom4
]

export class ZoomImagen extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            countScroll: 0,
            zoomActivo: false
        }
        this.preventDefault = this.preventDefault.bind(this)
        //Función para volver a mover el scrollbar con la rueda de el mouse
        this.enableScroll = () => {
            document.removeEventListener('wheel', this.preventDefault, false)
        }
        //Función para evitar que se mueva el scrollbar con la rueda de el mouse al realizar el zoom
        this.disableScroll = () => {
            document.addEventListener('wheel', this.preventDefault, {
                passive: false,
            })
        }
        //Setea la variable de scroll para activar el zoom y llama al evento de deshabilitar la scrollbar
        //Se activa cuando se ubica el puntero de el mouse sobre la imagen
        this.mouseEnterImagen = ()=>{
            this.setState({
                countScroll: 0,
                zoomActivo: true
            }, ()=> this.disableScroll())
        }
        //Setea la variable de scroll para desactivar el zoom y llama al evento de habilitar la scrollbar
        //Se activa cuando se quita el puntero de el mouse sobre la imagen
        this.mouseLeaveImagen = ()=>{
            this.setState({
                countScroll: 0,
                zoomActivo: false
            }, ()=> this.enableScroll())
        }
    }
    //Evento para cambiar el contador de el zoom cuando de mueva la rueda de el mouse
    //si evt.detay > 0 disminuye zoom sino lo aumenta
    preventDefault(evt) {
        evt = evt || window.event
        if (evt.preventDefault) {
          evt.preventDefault()
        }
        evt.returnValue = false
        //Obtener valor actual de el scroll
        var countScroll = this.state.countScroll
        if( this.state.zoomActivo){
            if(evt.deltaY > 0){
                this.setState({
                    countScroll: countScroll > 0? countScroll - 1 : countScroll
                })
            }else{
                this.setState({
                    countScroll: countScroll < 4? countScroll + 1 : countScroll
                })
            }
        }
    }
    render() {
        return (
            <div>
                <p className={css.tooltip}>
                    <img src={`${this.props.ruta_imagen}`} className={css.imagenOriginal}/>
                    <span className={css.tooltiptext}>
                        <img 
                            src={`${this.props.ruta_imagen}`} 
                            className={zoomImagen[this.state.countScroll]}
                            onMouseEnter={this.mouseEnterImagen}
                            onMouseLeave={this.mouseLeaveImagen}
                        />
                    </span>
                </p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/components/ZoomImagen/ZoomImagen.jsx